import { useMemo } from "react";
import { ConnectProto } from "@racoon/api";
import { useT } from "@racoon/i18n";
import { buildDriverShiftGroups, buildTruckShiftGroups } from "../helpers/shiftGroups";
import type { ShiftData } from "./shift-data";
import { useShiftsView } from "./use-shifts-view";

/**
 * The registry's shifts grouped the way its current view shows them. The cascade
 * renders these; the Excel export flattens them, so the file follows the view's
 * group order.
 */
export const useShiftGroups = ({
  shifts,
  trucks,
}: {
  shifts: ShiftData[];
  /** Active fleet — trucks lead the truck view and carry its header data. */
  trucks: ConnectProto.Truck[];
}) => {
  const t = useT();
  const { view } = useShiftsView();

  const groups = useMemo(
    () =>
      view === "driver"
        ? buildDriverShiftGroups({ shifts })
        : buildTruckShiftGroups({ trucks, shifts, t }),
    [view, trucks, shifts, t],
  );

  return { view, groups };
};
